import {Observable} from "rxjs";
import {tap} from "rxjs/operators";

/**
 * It calls onErrorCallBack function when the source observable emits an error;
 * @param onErrorCallBack - (error: any) => void
 * @returns A function that takes an Observable and returns an Observable.
 */
export function onError(onErrorCallBack: (error: any) => void ) {
    return function <T>(source: Observable<T>): Observable<T> {
        return source.pipe(
            tap({error: error => onErrorCallBack(error)}),
        )
    }
}